import React, { useState, useEffect } from 'react';
import { AddButton, DeleteButton, Space } from '../../Res/BaseButton';
import { uuid, getItemsInfo } from '../../../../item/ItemTools';
import { SingleInput, SingleText, SingleSelect } from '../../Res/BaseInput';
import { RespCustomerPositionInfo_Insurance, InsuranceSOPType_Arr, DateOfInsurance_Arr, LaborInsuranceType_Arr, GroupInsuranceType_Arr, InsuranceBurdenType_Arr } from '../../../../item/ItemCustomerPosition';
import { getTexIdNumber } from '../../../Login/Auth';
import { api_getLaborInsuranceLevel_Arr, api_getHealthInsuranceLevel_Arr } from '../../../../api/apiOpenData';


export function ItemInsurance({ item, action, isEdit = true }) {
  const [insuranceInfo, setInsurance] = useState({})

  const [insuranceSOPTpye, setInsuranceSOPType] = useState("")
  const [dateOfInsurance, setDateOfInsurance] = useState("")
  const [insuredUnitGUI, setInsuredUnitGUI] = useState("")
  const [laborInsuranceType, setLaborInsuranceType] = useState("")
  const [laborInsuranceLevel, setLaborInsuranceLevel] = useState("")
  const [laborInsuranceLevel_Arr, setLaborInsuranceLevel_arr] = useState([])
  const [healthInsuranceLevel, setHealthInsuranceLevel] = useState("")
  const [healthInsuranceLevel_Arr, setHealthInsuranceLevel_Arr] = useState([])
  const [groupInsuranceType, setGroupInsuranceType] = useState("")
  const [groupInsuranceBurdenType, setGroupInsuranceBurdenType] = useState("")
  const [dateOfGroupInsurance, setDateOfGroupInsurance] = useState("")
  const [groupInsuranceGUI, setGroupInsuranceGUI] = useState("")
  const [groupInsurancePremium, setGroupInsurancePremium] = useState(0)

  const Tilel_InsuranceSOPType = "保險作業方式"
  const Tilel_DateOfInsurance = "應加保日期"
  const Tilel_LaborInsuranceType = "勞保類別"
  const Tilel_LaborInsuranceLevel = "勞保投保級距"
  const Tilel_HealthInsuranceLevel = "健保投保級距"
  const Tilel_InsuredUnitGUI = "投保公司統編"
  const Tilel_GroupInsuranceType = "團保方式"
  const Tilel_GroupInsuranceBurdenType = "團保費用"
  const Tilel_DateOfGroupInsurance = "應加保日期"
  const Tilel_GroupInsuranceGUI = "保險公司統編"
  const Tilel_GroupInsurancePremium = "每人每日保費金額"

  useEffect(() => {
    getLaborInsuranceLevel_Arr()
    getHealthInsuranceLevel_Arr()
  }, [])

  useEffect(() => {
    if (item !== undefined && insuranceInfo !== item) {
      setInsurance(item)
      var mRespCustomerPositionInfo_Insurance = new RespCustomerPositionInfo_Insurance({})
      mRespCustomerPositionInfo_Insurance.fromJson(item)
      // console.log(mRespCustomerPositionInfo_Insurance)
      setInsuranceSOPType(mRespCustomerPositionInfo_Insurance.insuranceSOPTpye)
      setDateOfInsurance(mRespCustomerPositionInfo_Insurance.dateOfInsurance)
      var iuGUI = mRespCustomerPositionInfo_Insurance.insuredUnitGUI
      if (iuGUI === undefined || iuGUI === "") {
        iuGUI = getTexIdNumber()
        setInsuredUnitGUI(iuGUI)
      }else{
        setInsuredUnitGUI(mRespCustomerPositionInfo_Insurance.insuredUnitGUI)
      }
      setLaborInsuranceType(mRespCustomerPositionInfo_Insurance.laborInsuranceType)
      setLaborInsuranceLevel(mRespCustomerPositionInfo_Insurance.laborInsuranceLevel)
      setHealthInsuranceLevel(mRespCustomerPositionInfo_Insurance.healthInsuranceLevel)
      setGroupInsuranceType(mRespCustomerPositionInfo_Insurance.groupInsuranceType)
      setGroupInsuranceBurdenType(mRespCustomerPositionInfo_Insurance.groupInsuranceBurdenType)
      setDateOfGroupInsurance(mRespCustomerPositionInfo_Insurance.dateOfGroupInsurance)
      setDateOfGroupInsurance(mRespCustomerPositionInfo_Insurance.dateOfGroupInsurance)
      setGroupInsuranceGUI(mRespCustomerPositionInfo_Insurance.groupInsuranceGUI)
      setGroupInsurancePremium(mRespCustomerPositionInfo_Insurance.groupInsurancePremium)
    }
  }, [item])

  useEffect(() => {
    if (action !== undefined) {
      var mInfo = new RespCustomerPositionInfo_Insurance({
        insuranceSOPTpye,       //保險作業方式
        dateOfInsurance,        //勞健保應加保日期
        laborInsuranceType,     //勞保類別
        laborInsuranceLevel,    //勞保投保級距
        healthInsuranceLevel,    //健保投保級距
        insuredUnitGUI,         //勞健保投保公司統編
        groupInsuranceType,     //團保方式
        groupInsuranceBurdenType, //團保費用
        dateOfGroupInsurance,   //團保應加保日期
        groupInsuranceGUI,       //團保保險公司統編
        groupInsurancePremium   //每人每日保費金額
      })
      // console.log(mInfo)
      action(mInfo)
    }
  }, [insuranceSOPTpye, dateOfInsurance, laborInsuranceType, laborInsuranceLevel, healthInsuranceLevel,
    insuredUnitGUI, groupInsuranceType, groupInsuranceBurdenType, dateOfGroupInsurance, groupInsuranceGUI, groupInsurancePremium, action])

  function getLaborInsuranceLevel_Arr() {
    api_getLaborInsuranceLevel_Arr({
      success: (jsonData) => {
        try {
          var detail = JSON.parse(jsonData.detail.info)
          setLaborInsuranceLevel_arr(detail)
          //console.log(detail)
        } catch (error) {
          console.log(error)
        }
      },
      failure: (err) => {

      }
    })
  }

  function getHealthInsuranceLevel_Arr() {
    api_getHealthInsuranceLevel_Arr({
      success: (jsonData) => {
        //console.log(jsonData)
        var detail = JSON.parse(jsonData.detail.info)
        setHealthInsuranceLevel_Arr(detail)
      },
      failure: (err) => {

      }
    })
  }

  return (
    <>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>保險條件-勞健保</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleSelect title={Tilel_InsuranceSOPType}
              val={insuranceSOPTpye}
              attr={InsuranceSOPType_Arr}
              action={setInsuranceSOPType}
              hasBlank={true}
              blankVal={"0"}
              size={2}
            />
            : <SingleText
              title={Tilel_InsuranceSOPType}
              val={getItemsInfo({
                items: InsuranceSOPType_Arr,
                val: insuranceSOPTpye
              })}
              size={2} />
          }
          {isEdit ?
            <SingleSelect title={Tilel_DateOfInsurance}
              val={dateOfInsurance}
              attr={DateOfInsurance_Arr}
              action={setDateOfInsurance}
              hasBlank={true}
              blankVal={"0"}
              size={2}
            />
            : <SingleText
              title={Tilel_DateOfInsurance}
              val={getItemsInfo({
                items: DateOfInsurance_Arr,
                val: dateOfInsurance
              })}
              size={2} />
          }
          {isEdit ?
            <SingleSelect title={Tilel_LaborInsuranceType}
              val={laborInsuranceType}
              attr={LaborInsuranceType_Arr}
              action={setLaborInsuranceType}
              hasBlank={true}
              blankVal={"0"}
              size={2}
            />
            : <SingleText
              title={Tilel_LaborInsuranceType}
              val={getItemsInfo({
                items: LaborInsuranceType_Arr,
                val: laborInsuranceType
              })}
              size={2} />
          }
          {isEdit ?
            <SingleSelect title={Tilel_LaborInsuranceLevel}
              val={laborInsuranceLevel}
              attr={laborInsuranceLevel_Arr[laborInsuranceType + ""] === undefined ? [] : laborInsuranceLevel_Arr[laborInsuranceType + ""]}
              action={setLaborInsuranceLevel}
              v={"level"}
              n={"amount"}
              optionN={[
                { ov: "n", on: "第" },
                { ov: "k", on: "level" },
                { ov: "n", on: "級" },
                { ov: "n", on: " " },
                { ov: "k", on: "amount" },
              ]}
              hasBlank={true}
              size={2}
            />
            : <SingleText
              title={Tilel_LaborInsuranceLevel}
              val={getItemsInfo({
                items: laborInsuranceLevel_Arr[laborInsuranceType + ""] || [],
                val: laborInsuranceLevel,
                key: "level",
                name: "amount",
                optionN: [
                  { ov: "n", on: "第" },
                  { ov: "k", on: "level" },
                  { ov: "n", on: "級" },
                  { ov: "n", on: " " },
                  { ov: "k", on: "amount" },
                ]
              })}
              size={2} />
          }
          {/* <SingleText
    title={"月投保薪資"}
    val={getItemsInfo({
      items: laborInsuranceLevel_Arr[laborInsuranceType],
      val: laborInsuranceLevel,
      key: "level",
      name: "amount"
    })}
    size={3} /> */}

          {isEdit ?
            <SingleSelect title={Tilel_HealthInsuranceLevel}
              val={healthInsuranceLevel}
              attr={healthInsuranceLevel_Arr}
              action={setHealthInsuranceLevel}
              v={"level"}
              n={"amount"}
              optionN={[
                { ov: "n", on: "第" },
                { ov: "k", on: "level" },
                { ov: "n", on: "級" },
                { ov: "n", on: " " },
                { ov: "k", on: "amount" },
              ]}
              hasBlank={true}
              blankVal={"0"}
              size={2}
            // debug={true}
            />
            : <SingleText
              title={Tilel_HealthInsuranceLevel}
              val={getItemsInfo({
                items: healthInsuranceLevel_Arr,
                val: healthInsuranceLevel,
                key: "level",
                name: "amount",
                optionN: [
                  { ov: "n", on: "第" },
                  { ov: "k", on: "level" },
                  { ov: "n", on: "級" },
                  { ov: "n", on: " " },
                  { ov: "k", on: "amount" },
                ]
              })}
              size={2} />
          }
          {
            isEdit ?
              <SingleInput title={Tilel_InsuredUnitGUI}
                val={insuredUnitGUI}
                action={setInsuredUnitGUI}
                size={2}
              />
              :
              <SingleText title={Tilel_InsuredUnitGUI} val={insuredUnitGUI} size={2} />
          }
          {/* <SingleText
    title={"月投保金額"}
    val={getItemsInfo({
      items: healthInsuranceLevel_Arr,
      val: healthInsuranceLevel,
      key: "level",
      name: "amount",
      debug: true
    })}
    size={3} /> */}
        </div>
      </div>
      <Space />
      <Space />
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>保險條件-團保</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleSelect title={Tilel_GroupInsuranceType}
              val={groupInsuranceType}
              attr={GroupInsuranceType_Arr}
              action={setGroupInsuranceType}
              hasBlank={true}
              blankVal={""}
              size={2}
            />
            : <SingleText
              title={Tilel_GroupInsuranceType}
              val={getItemsInfo({
                items: GroupInsuranceType_Arr,
                val: groupInsuranceType
              })}
              size={2} />
          }
          {/* {groupInsuranceType === ""?<></>: */}
          {
            isEdit ?
              <SingleSelect title={Tilel_DateOfGroupInsurance}
                val={dateOfGroupInsurance}
                attr={DateOfInsurance_Arr}
                action={setDateOfGroupInsurance}
                hasBlank={true}
                blankVal={""}
                size={2}
              />
              : <SingleText
                title={Tilel_DateOfGroupInsurance}
                val={getItemsInfo({
                  items: DateOfInsurance_Arr,
                  val: dateOfGroupInsurance
                })}
                size={2} />
          }
          {
            isEdit ?
            <SingleSelect title={Tilel_GroupInsuranceBurdenType}
              val={groupInsuranceBurdenType}
              attr={InsuranceBurdenType_Arr}
              action={setGroupInsuranceBurdenType}
              hasBlank={true}
              size={2}
            />
            : <SingleText
              title={Tilel_GroupInsuranceBurdenType}
              val={getItemsInfo({
                items: InsuranceBurdenType_Arr,
                val: groupInsuranceBurdenType
              })}
              size={2} />
          }
          {/* {groupInsuranceType === ""?<></>: */}
          {
            isEdit ?
              <SingleInput title={Tilel_GroupInsuranceGUI}
                val={groupInsuranceGUI}
                action={setGroupInsuranceGUI}
                size={2}
                placeholder={"統編"}
              />
              :
              <SingleText title={Tilel_GroupInsuranceGUI} val={groupInsuranceGUI} size={2} />
          }
          {
            isEdit ?
              <SingleInput title={Tilel_GroupInsurancePremium}
                val={groupInsurancePremium}
                action={setGroupInsurancePremium}
                size={2}
                type={"number"}
              />
              :
              <SingleText title={Tilel_GroupInsurancePremium} val={groupInsurancePremium} size={2} />
          }
        </div>
      </div>
    </>
  )
}